import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpreadingState } from '@components/main/spreading/state/manager';
import { Row } from '@components/main/spreading/models/models';

@Component({
  selector: 'app-categorization-manual-item-view',
  templateUrl: './manual-item-view.component.html',
  styleUrls: ['./manual-item-view.component.scss'],
  standalone: false
})
export class ManualItemViewComponent {
  @Input() state: SpreadingState;
  @Input() row: Row;

  @Output() insertItem = new EventEmitter<void>();

  onInsertItem(): void {
    this.insertItem.emit();
  }
}
